/**
 * Lettura sessione persistita (localStorage) per sopravvivere a reload PWA offline.
 */

/**
 * @returns {Record<string, unknown> | null}
 */
export function readPersistedAdamsUser() {
  try {
    const raw = localStorage.getItem('adams_user')
    return raw ? JSON.parse(raw) : null
  } catch {
    return null
  }
}

/**
 * @param {Record<string, unknown> | null} [user]
 */
export function isOfflineSessionUser(user = readPersistedAdamsUser()) {
  if (!user) return false
  return Boolean(user.isOfflineSession || user.token === '__offline__')
}

/**
 * @param {string | null | undefined} token
 */
export function isOfflineSessionToken(token) {
  return token === '__offline__'
}

/**
 * @param {Record<string, unknown> | null} [user]
 */
export function hasValidPersistedSession(user = readPersistedAdamsUser()) {
  if (!user) return false
  if (isOfflineSessionUser(user) && user.init?.configuration) return true
  if (user.timestamp && Date.now() < Number(user.timestamp) && user.token) return true
  return false
}

/**
 * @returns {string | null}
 */
export function resolveSessionToken(locationState) {
  if (locationState?.token) return locationState.token
  const user = readPersistedAdamsUser()
  if (user?.isOfflineSession) return user.token || '__offline__'
  return user?.token || localStorage.getItem('token') || null
}

/**
 * @returns {object | null}
 */
export function resolveSessionInit(locationState) {
  if (locationState?.init?.configuration) return locationState.init
  const user = readPersistedAdamsUser()
  return user?.init?.configuration ? user.init : null
}

/**
 * Evita chiamate API che possono causare 401 e logout forzato.
 */
export function shouldSkipOnlineApiCalls() {
  if (typeof navigator !== 'undefined' && !navigator.onLine) return true
  return isOfflineSessionUser()
}

/**
 * Non cancellare la sessione locale su 401 (offline o token dedicato).
 */
export function shouldPreserveLocalSessionOnAuthError() {
  return shouldSkipOnlineApiCalls()
}
